import { Component, Inject, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'picture-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class PictureFormDialogComponent implements OnInit
{
  action: string;
  dialogTitle;
  eventType;
  public img: any = '';
  public uploadedImg = null;
    constructor(
        public dialogRef: MatDialogRef<PictureFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    )
    {
        this.action = data.action;

        if ( this.action === 'edit' )
        {
            this.dialogTitle = 'picture.edit';
            this.eventType = data.type;
        }
        else
        {
            this.dialogTitle = 'picture.new';
        }
    }

    ngOnInit()
    {

    }

  setImg(img){
    this.uploadedImg = img;
  }
}
